import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { useHeaderContext } from '@context';
import styles from './styles/index.module.scss';

const Logo = ({ className }) => {
  const { platformBaseUrl } = useHeaderContext();

  return (
    <a
      href={`${platformBaseUrl}/`}
      className={cn(styles.logo, className)}
      data-qa="logoHomeCta"
    >
      <span className={styles.logoText}>ManoMano</span>
    </a>
  );
};

Logo.propTypes = {
  className: PropTypes.string,
};

Logo.defaultProps = {
  className: null,
};

Logo.displayName = 'Logo';

export default Logo;
